export const DISCHARGE_REASONS_LABELS = [
  {
    key: '0',
    text: 'The client has mastered all treatment goals, and no new goals are identified',
  },
  {
    key: '1',
    text: 'All maladaptive behavior goals have been mastered and generalized',
  },
  {
    key: '2',
    text: 'No new behaviors have emerged',
  },
  {
    key: '3',
    text: 'Client’s Vineland-3 scores have reached a level in accordance with similar-aged peers',
  },
  {
    key: '4',
    text: 'Client’s AFLS scores have reached a level in accordance with similar-aged peers',
  },
  {
    key: '5',
    text: 'Client’s parents/caregivers report confidence in continuing ABA intervention techniques',
  },
  {
    key: '6',
    text: 'Client no longer able to participate due to medical reasons',
  },
  {
    key: '7',
    text: 'Parents prefer a new provider',
  },
  {
    key: '8',
    text: 'Client no longer able to participate due to personal changes',
  },
  {
    key: '9',
    text: 'No progress has been made for 3 months',
  },
  {
    key: '10',
    text: 'Goals are not maintaining or generalizing',
  },
];
